<template>
   <div>
        <!-- DIALOGS -->
        <SelectionRequiredDialog /> 
		<DeletionDialog :context="'Selected' + context" />

		<BaseListPage
			headline="lang_ERP_INVOICES"
            :context="context"
            alvqa="erp-invoices"
            searchCols="2"
            :stickyHeader="true"
		>
        <template v-slot:filter>
            <v-col>
                <DropdownFilter 
                    :context="context + 'TypeFilter'"
                    label="lang_ERP_INVOICES_CAPTION_TYPE"
                    :items="typeItems"
                    :alvqa="alvqa + '-list-dropdown-type-filter'"
                />
            </v-col>
            <v-col cols="2">
                <DropdownFilter 
                    :context="context + 'StatusFilter'"
                    label="lang_ERP_INVOICES_CAPTION_STATUS"
                    :items="statusItems"
                    :alvqa="alvqa + '-list-dropdown-status-filter'"
                />
            </v-col>
            <v-col cols="2">
                <DatePickerFilter 
                    :context="context + 'PeriodFromFilter'"
                    :label="$t('lang_GENERIC_CAPTION_PERIOD_FROM')"
                    :alvqa="alvqa"
                />
            </v-col>
            <v-col cols="2">
                <DatePickerFilter 
                    :context="context + 'PeriodToFilter'"
                    :label="$t('lang_GENERIC_CAPTION_PERIOD_TO')"
                    :alvqa="alvqa"
                />
            </v-col>
            <v-col cols="2">
                <DropdownFilter 
                    :context="context + 'PeriodDateFilter'"
                    label="lang_GENERIC_CAPTION_DATE"
                    :items="periodDateItems"
                    :clearable="false"
                    :alvqa="alvqa + '-list-dropdown-date-filter'"
                />                
            </v-col>
        </template>
        <template v-slot:dataTable>
            <BaseDataTableList 
                :headers="headers"
                :context="context"
                readOnlyGhostTdSpan="1"
                :hasServerSideSorting="true"
                alvqa="erp-invoices"
                :stickyTopSlot="true"
            >	
        <template v-slot:topSlot> <InvoicesTopSlot /> </template> 

<!-- DOES NOT WORK, JUST TRYING OUT -->
        <template v-slot:headers="{ header }">
            {{ header }}
        </template>

            <template v-slot:body="{ item }">

                <ExpandIcon 
                    :isExpanded="item.isExpanded" 
                    :alvqa="alvqa + '-row-' + item.item.alvId + '-icon-expand'"
                />
                
                <td class="no_ellipsis" :alvqa=" alvqa + '-row-' + item.item.alvId + '-text-invoice-number'">
                    {{ item.item.number }}</td>
                
                <td class="no_ellipsis" :alvqa="alvqa + '-row-' + item.item.alvId + '-text-invoice-date'">
                    {{ $d(new Date(item.item.date), 'alvDateFormat', $i18n.locale) }}</td>
                
                <td class="no_ellipsis" :alvqa="alvqa + '-row-' + item.item.alvId + '-text-invoice-type'">
                    <BaseTooltip>
                    <template v-slot:text>{{ $t(getLangOfType(item.item.type)) }}</template>
                        <template v-slot:content>
                            <span :alvqa="alvqa + '-row-' + item.item.alvId + '-text-invoice-type'">
                                {{ $t(getLangOfType(item.item.type, "abbr")) }}
                            </span>
                        </template>
                    </BaseTooltip>
                </td>

                <td class="ellipsis">
                    <BaseTooltip>
                        <template v-slot:text>{{ item.item.recipientName + ' (' + item.item.recipient.alvId + ')'}}</template>
                        <template v-slot:content>
                            <span :alvqa="alvqa + '-row-' + item.item.alvId + '-text-invoice-recipient'">
                                {{ item.item.recipientName }}
                            </span>
                        </template>
                    </BaseTooltip>
                </td>
                
                <td class="no_ellipsis text-right" :alvqa="alvqa + '-row-' + item.item.alvId + '-text-invoice-sum-net'">
                    <!-- {{ $n(item.item.sumNet, 'number') }} -->
                    {{ $n(getSumNetConverted(item), 'number') }}
                </td>
                
                <td class="no_ellipsis" :alvqa="alvqa + '-row-' + item.item.alvId + '-text-invoice-status'">
                    {{ $t(getLangOfStatus(item.item.status)) }}
                </td>
                
                <td>
                    
                    <BaseTooltip v-if="item.item.linkedDocument != null">
                        <template v-slot:text>
                            {{ $t(getLangOfLinkedDocumentType(item.item.linkedDocument.type, 'text')) }}
                            {{ item.item.linkedDocument.number }} <br />
                            <div style="text-align:center">{{ item.item.linkedDocument.alvId }}</div>
                        </template>
                        <template v-slot:content>
                            <BaseButton 
                                :label="getLangOfLinkedDocumentType(item.item.linkedDocument.type, 'text')"
                                @click.stop="jumpToDocument(item.item.linkedDocument.type, item.item.linkedDocument.alvId)"
                                :alvqa="alvqa + '-row-' + item.item.alvId + '-button-'+ item.item.linkedDocument.type"
                            />
                        </template>
                    </BaseTooltip>

                </td>
            
            </template>
            <!-- EXPAND: Read Only View -->
            <template v-slot:expandSlot="{ id }"><InvoicesReadOnly :itemId='id' /></template>
            </BaseDataTableList>
        </template>
		</BaseListPage>
    </div> 
</template>

<script>
    import { mapGetters } from 'vuex'
    import BaseButton from '@/components/_buttons/BaseButton'
    import BaseDataTableList from '@/components/_base/BaseDataTableList'
    import BaseListPage from '@/components/_base/BaseListPage'
    import BaseTooltip from '@/components/_base/BaseTooltip'
    import BaseIcon from '@/components/_buttons/BaseIcon'
    import ExpandIcon from '@/components/_buttons/ExpandIcon'
    import InvoicesReadOnly from './_readonly/InvoicesReadOnly'
    import DropdownFilter from '@/components/_filters/DropdownFilter'
    import DatePickerFilter from '@/components/_filters/DatePickerFilter'
    import InvoicesTopSlot from './InvoicesTopSlot'
    import DeletionDialog from '@/components/_dialogs/DeletionDialog'
    import SelectionRequiredDialog from '@/components/_dialogs/SelectionRequiredDialog'
    import {    DropdownErpInvoicesStatus,
                DropdownErpInvoicesType,
                DropdownErpLinkedDocumentType,
                } from '@/assets/dropdowns/alvDropdowns.js'

    export default {
	    name: 'InvoicesList',						
	    components: {
            BaseButton,
            BaseListPage,
            BaseDataTableList,
            BaseTooltip,
            InvoicesTopSlot,
            BaseIcon,
            ExpandIcon,
            DeletionDialog,
            InvoicesReadOnly,
            SelectionRequiredDialog,
            DropdownFilter,
            DatePickerFilter
        },
        data() {
            return {
                context: "Invoices",
                alvqa: "erp-invoices-list"
            }
        },
        methods: {
            getLangOfStatus(selection) {
                return DropdownErpShippingStatus.find(obj => {
                    return obj.value == selection
                }).text
            },
            getLangOfStatus(selection) {
                return DropdownErpInvoicesStatus.find(obj => {
                    return obj.value == selection
                }).text
            },
            getLangOfType(selection, type = "text") {
                return DropdownErpInvoicesType.find(obj => {
                    return obj.value == selection
                })[type]
            },
            getLangOfLinkedDocumentType(selection, type = "text") {
                return DropdownErpLinkedDocumentType.find(obj => {
                    return obj.value == selection
                })[type]
            },
            getSumNetConverted(item) {
                if (item.item.conversionFactor) {
                    return item.item.sumNet * item.item.conversionFactor 
                } else {
                    return item.item.sumNet
                }
            },
            jumpToInvoice(alvId) {
                this.$store.commit('setInvoicesSearch', alvId)
                this.$store.commit('setExpandedInvoices', [])
                this.$store.commit('setExpandedInvoices', alvId)
                this.$router.push( { name: 'Invoices' })
                this.$store.dispatch('fetchInvoicesDetails', alvId)
            },
            jumpToShipping(alvId) {
                this.$store.commit('setShippingSearch', alvId)
                this.$store.commit('setExpandedShipping', [])
                this.$store.commit('setExpandedShipping', alvId)
                this.$router.push( { name: 'Shipping' })
                this.$store.dispatch('fetchShippingDetails', alvId)
            },
            jumpToSalesdata(alvId) {
                this.$store.commit('setSalesDataSearch', alvId)
                this.$store.commit('setExpandedSalesData', [])
                this.$store.commit('setExpandedSalesData', alvId)
                this.$router.push( { name: 'SalesData' })
                this.$store.dispatch('fetchSalesDataDetails', alvId)
            },
            jumpToDocument(type, alvId) {
                switch (type) {
                    case 'reg':
                        this.jumpToInvoice(alvId)
                        break;
                    case 'incoming':
                        this.jumpToShipping(alvId)
                        break;
                    case 'shipping':
                        this.jumpToShipping(alvId)
                        break;
                    case 'picking':
                        this.jumpToShipping(alvId)
                        break;
                    case 'returning':
                        this.jumpToShipping(alvId)
                        break;
                    case 'sales':
                        this.jumpToSalesdata(alvId)
                        break;
                    default:
                        break;
                }
            }
        },
        computed: {
            ...mapGetters(['getInvoicesSearch']),

            headers() {
                return [
                    { // column 01: Select
                        text: '', 
                        value: 'data-table-select', 
                        width: "60px",
                        sortable: false,
                        class: 'text-no-wrap'
                    },
                    { // column 02: Read-only view
                        text: '', 
                        value: 'data-table-expand',
                        align: 'center', 
                        width: "48px",
                        sortable: false,
                        class: 'text-no-wrap'
                    },
                    { // column 03: invoice Number
                        text: this.$t('lang_ERP_INVOICES_CAPTION_NUMBER_ABBREVIATION'), 
                        value: 'number', 
                        align: 'left', 
                        width: "160px",
                        sortable: true,
                        class: 'text-no-wrap',
                        // TODO_PT: finalize alvqa for headers in baselistepage base component
                        alvqa: 'schnippschnapp' 
                    },
                    { // column 04: invoice Date
                        text: this.$t('lang_ERP_INVOICES_CAPTION_DATE_ABBREVIATION'), 
                        value: 'date', 
                        align: 'left', 
                        width: "90px",
                        sortable: true,
                        class: 'text-no-wrap'
                    },
                    { // column 05: invoice Type
                        text: this.$t('lang_ERP_INVOICES_CAPTION_TYPE'), 
                        value: 'type', 
                        align: 'left', 
                        width: "50px",
                        sortable: false,
                        class: 'text-no-wrap'
                    },
                    { // column 06: invoice Recipient
                        text: this.$t('lang_ERP_INVOICES_CAPTION_RECIPIENT_ABBREVIATION'), 
                        value: 'recipientName', 
                        align: 'left', 
                        sortable: true,
                        class: 'text-no-wrap'
                    },
                    { // column 07: invoice Sum Net
                        text: this.$t('lang_ERP_INVOICES_CAPTION_SUM_NET') + ' ' + this.$store.getters.getSelectedCurrency, 
                        value: 'sumNet', 
                        align: 'end', 
                        width: "100px",
                        sortable: true,
                        class: 'text-no-wrap'
                    },
                    { // column 08: invoice Status
                        text: this.$t('lang_ERP_INVOICES_CAPTION_STATUS'), 
                        value: 'status', 
                        align: 'left', 
                        width: "130px",
                        sortable: false,
                        class: 'text-no-wrap'
                    },
                    { // column 09: invoice Linked Document
                        text: this.$t('lang_ERP_INVOICES_CAPTION_LINKED_DOC_ABBREVIATION'), 
                        value: 'linkedDocument', 
                        align: 'left', 
                        width: "200px",
                        sortable: false,
                        class: 'text-no-wrap'
                    },
                    {
                        text: '', 
                        value: 'editForm',
                        align: 'right',
                        sortable: false,
                        width: "70px",
                        class: 'text-no-wrap'
                    }
                ]
            },
            statusItems() { 
                let dropdownItems = JSON.parse(JSON.stringify(DropdownErpInvoicesStatus))
                dropdownItems.push({
                    text: this.$t('lang_ERP_INVOICES_DROPDOWN_STATUS_OPEN') + ' + ' + this.$t('lang_ERP_INVOICES_DROPDOWN_STATUS_OVERDUE'), 
                    value: 6,
                    alvqa: 'dropdown-status-open-and-overdue'
                })
                return dropdownItems
            },
            typeItems() { return DropdownErpInvoicesType },
            periodDateItems() {
                return [
                    {
                        text: this.$t('lang_ERP_INVOICES_CAPTION_DATE'),
                        value: 'invoicesDate',
                        alvqa: 'dropdown-date-invoices-date'
                    },
                                        {
                        text: '"' + this.$t('lang_ERP_INVOICES_CAPTION_PAIDDATE') + '" ' + this.$t('lang_GENERIC_CAPTION_DATE'),
                        value: 'paidDate',
                        alvqa: 'dropdown-date-paid-date'
                    },
                    
                ]
            }
        }
}
</script>